module.exports = __webpack_public_path__ + "img/ewh-7.aea0c7e4.png";